import { SupportBundle } from "@/features/admin/support-bundle";

export default function AdminSupportBundlePage() {
  return <SupportBundle />;
}
